import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { theme } from 'styles/theme/hav-theme'

type ContainerProps = {
  collapsed: boolean
}

type ItemProps = {
  active?: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.xm};
  gap: ${theme.spacing.sm};
  background-color: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.sm};
  box-shadow: ${theme.effects.boxShadow.card};
  overflow: hidden;
  min-width: 76px;
  width: 190px;
  transition: width 0.2s ease-in-out;

  ${({ collapsed }) =>
    collapsed &&
    css`
      span {
        display: none;
      }
      width: 76px;
    `}
`

export const StyledItem = styled.div<ItemProps>`
  display: flex;
  position: relative;
  height: 36px;
  gap: ${theme.spacing.xs};
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px;
  background-color: transparent;
  transition: 0.2s ease-in-out;
  white-space: nowrap;

  svg {
    min-width: ${theme.spacing.xm};
    min-height: ${theme.spacing.xm};
    width: ${theme.spacing.xm};
    height: ${theme.spacing.xm};
    path {
      fill: ${theme.colors.neutral.high};
    }
  }

  span {
    font-size: ${theme.typography.sizes['2xs']};
    font-family: ${theme.typography.family.bold};
    color: ${theme.colors.neutral.high};
  }

  :hover {
    background-color: ${theme.colors.quartenary};
  }

  ${({ active }) =>
    active &&
    css`
      background-color: ${theme.colors.quartenary};

      svg {
        path {
          fill: ${theme.colors.primary.main};
        }
      }

      span {
        color: ${theme.colors.primary.main};
      }
    `}
`

export const ExpandWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const ExpandButton = styled.button<ContainerProps>`
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: 0.2s ease-in-out;

  :hover {
    background-color: ${theme.colors.quartenary};
  }

  svg {
    transition: transform 0.2s ease-in-out;
    transform: rotate(180deg);
  }

  ${({ collapsed }) =>
    collapsed &&
    css`
      svg {
        transform: rotate(0deg);
      }
    `}
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
  width: 100%;
`
